<template>
  <div class="confirm-page">
    <div class="hero-background">
      <img
        :src="require(`../brand/${brandConfig.brand}/assets/evina-img.webp`)"
        class="hero-image"
        alt="Battle League Gaming"
      />
      <div class="hero-overlay"></div>
    </div>

    <div class="content-panel">
      <img
        :src="require(`../brand/${brandConfig.brand}/assets/logo.png`)"
        class="brand-logo"
        alt="BLG"
      />

      <div class="welcome-copy">
        <div>Welcome to</div>
        <div>Battle League Gaming</div>
      </div>

      <div class="body-copy">
        Where you'll have the chance to compete, conquer,
        and rise in the ranks of tournament gaming!
      </div>

      <div class="instruction-copy">
        Please confirm your subscription to Battle League
        Gaming for {{ brandConfig.price }}. Subscription service
      </div>

      <button class="primary-button" @click="onConfirmClicked">
        Confirm
      </button>

      <button class="secondary-button" @click="onCancelClicked">
        Cancel
      </button>

      <div class="terms-copy">
        By continuing you agree to the
        <a
          :href="brandConfig.termsAndConditionsUrl"
          target="_blank"
          rel="noreferrer"
        >
          terms &amp; conditions
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["brandConfig"]),
  },
  methods: {
    onConfirmClicked() {
      this.$router.push("/thank-you");
    },
    onCancelClicked() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.confirm-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: #000000;
  color: #ffffff;
}

.hero-background {
  position: absolute;
  inset: 0;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(0, 0, 0, 0.38) 0%, rgba(0, 0, 0, 0.22) 24%, rgba(0, 0, 0, 0.52) 58%, rgba(0, 0, 0, 0.94) 100%),
    linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.15) 35%, rgba(0, 0, 0, 0.72) 100%);
}

.content-panel {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.1rem 1.35rem 1.5rem;
  text-align: center;
}

.brand-logo {
  width: 138px;
  height: auto;
  margin-top: 0.3rem;
}

.welcome-copy {
  margin-top: 4.1rem;
  color: #ffffff;
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.35;
}

.body-copy {
  max-width: 18.5rem;
  margin-top: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
}

.instruction-copy {
  max-width: 17rem;
  margin-top: 8.3rem;
  color: #ffffff;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
}

.primary-button,
.secondary-button {
  width: 100%;
  border-radius: 6px;
  font-family: Inter, sans-serif;
  font-size: 25px;
  font-weight: 700;
  line-height: 1;
  border: none;
}

.primary-button {
  margin-top: 1.75rem;
  min-height: 90px;
  background: #c8ff3d;
  color: #000000;
}

.secondary-button {
  margin-top: 0.75rem;
  min-height: 90px;
  background: rgba(18, 18, 18, 0.58);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.terms-copy {
  margin-top: auto;
  padding-top: 1.4rem;
  color: rgba(255, 255, 255, 0.596);
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.25;
}

.terms-copy a {
  color: rgba(255, 255, 255, 0.596);
}
</style>
